import CaptaincyPoll from '@components/CaptaincyPoll';
import { MAX_GAMEWEEK } from '@lib/constants';
import { PostHogFeatureFlags } from '@lib/posthog-feature-flags';
import { useLeagueContext } from '@hooks/useLeagueContext';
import { usePostHogFeatureFlag } from '@hooks/usePostHogFeatureFlag';

/**
 * The weekly captaincy poll inside an article: the same poll, votes and rules
 * as the homepage card, behind the same flag, and hidden once the season is
 * over just as the sidebar hides it.
 */
export const CaptaincyPollBlock = () => {
  const { context: leagueContext } = useLeagueContext();
  const currentGameweek = leagueContext?.currentGameweek?.number ?? 0;
  const fplSeasonIsClosed = usePostHogFeatureFlag(
    PostHogFeatureFlags.fplSeasonIsClosed,
    false
  );
  const communityVoteIsLive = usePostHogFeatureFlag(
    PostHogFeatureFlags.communityVoteIsLive,
    false
  );

  if (!communityVoteIsLive) return null;
  if (fplSeasonIsClosed || currentGameweek === MAX_GAMEWEEK) return null;

  // The spacing goes on the card itself, so a week with no poll leaves no gap.
  return <CaptaincyPoll placement="article" className="not-prose my-8" />;
};
